// Access-method splits ("Swing-40;Chair-25;Robot-35").
// The grammar lives in percentSplits.js and is shared with damage-combination
// splits; this module supplies the `method` key that existing callers use.

import {
  PERCENT_TOTAL_TOLERANCE,
  buildSplitsValue,
  computeSplitAreas,
  formatArea,
  formatSplitAreasInline,
  getElementArea,
  parseSplitsValue,
  summarizeSplitAreas,
} from "./percentSplits";

export { PERCENT_TOTAL_TOLERANCE, getElementArea, formatArea };

export const parseAccessMethodsValue = (rawValue) =>
  parseSplitsValue(rawValue).map((split) => ({
    method: split.name,
    percentage: split.percentage,
  }));

export const buildAccessMethodsValue = (rows) =>
  buildSplitsValue(
    rows.map((row) => ({ name: row.method, percentage: row.percentage })),
  );

export const getElementMethodsValue = (el) =>
  String(el?.accessMethods ?? el?.access_methods ?? "").trim();

export const computeMethodAreas = (rawValue, area) =>
  computeSplitAreas(rawValue, area).map((split) => ({
    method: split.name,
    percentage: split.percentage,
    area: split.area,
  }));

export const summarizeMethodAreas = (elements) => {
  const summary = summarizeSplitAreas(elements, getElementMethodsValue);
  return {
    entries: summary.entries.map((entry) => ({
      method: entry.name,
      area: entry.area,
    })),
    unassignedArea: summary.unassignedArea,
  };
};

export const formatMethodAreasInline = (rawValue, area) =>
  formatSplitAreasInline(rawValue, area);
